import * as yup from 'yup';

export const AddPurchasedGiftCardSchema = yup.object().shape({
  giftCardNo: yup.string().required('Please enter a gift card number.'),
  discountDollars: yup.number().nullable(),
  discountPercentage: yup.number().nullable(),
  salesRep: yup.string().nullable(),
  initialBalance: yup.string().required('Enter the initial balance.')
});
